export default __webpack_public_path__ + "static/media/icons8-concrete.a9379ccb.svg";